import React from "react";
import PropTypes from "prop-types";

import { ListGroup, ListGroupItem, ListGroupItemHeading, ListGroupItemText } from "reactstrap";

import {
  toHibridDivisionFormat,
  toHibridClaimAreaFormat,
  toFormattedDate
} from "../../../utils/format";

const ExpandedRow = ({ data }) => {
  const { date, society, division, claimArea } = data;
  return (
    <table className="table-expanded-noHeader expanded-row">
      <tr className="body">
        <td />
        <td>
          <ListGroup>
            <ListGroupItem>
              <ListGroupItemHeading>Fecha</ListGroupItemHeading>
              <ListGroupItemText>{toFormattedDate(date)}</ListGroupItemText>
            </ListGroupItem>
            <ListGroupItem>
              <ListGroupItemHeading>División</ListGroupItemHeading>
              <ListGroupItemText>{toHibridDivisionFormat(division)}</ListGroupItemText>
            </ListGroupItem>
            <ListGroupItem>
              <ListGroupItemHeading>Área Reclamación</ListGroupItemHeading>
              <ListGroupItemText>{toHibridClaimAreaFormat(society, claimArea)}</ListGroupItemText>
            </ListGroupItem>
          </ListGroup>
        </td>
      </tr>
    </table>
  );
};

ExpandedRow.propTypes = {
  data: PropTypes.shape({
    date: PropTypes.string,
    society: PropTypes.string,
    division: PropTypes.string,
    claimArea: PropTypes.string
  }).isRequired
};

export default ExpandedRow;
